import Tooltip from '@atlaskit/tooltip';
import { resolvePartnerTier } from '@atlassian/mpac-ui';
import { css } from '@compiled/react';
import capitalize from 'lodash/capitalize';

import type { MarketplacePartnerTierType } from '@atlassian/mpac-types/graphql-gateway-types';

const PartnerBadgeImage = css({
  height: '1rem',
  width: '1rem',
});

const PartnerBadgeImageContainer = css({
  width: '1rem',
  height: '1rem',
});

export const PartnerBadge = (props: { partnerTier?: MarketplacePartnerTierType }) => {
  const partnerTierType = resolvePartnerTier(props.partnerTier);
  if (!partnerTierType) {
    return null;
  }
  const tooltipText = `${capitalize(partnerTierType.label.toLowerCase())} partner`;
  return (
    <Tooltip content={tooltipText}>
      <div css={PartnerBadgeImageContainer}>
        <img
          css={PartnerBadgeImage}
          alt={`${partnerTierType.label} Marketplace Partner`}
          src={partnerTierType.badge}
        />
      </div>
    </Tooltip>
  );
};
